var _rect, _rect2, _path, _path2, _rect3, _rect4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoatComputerSkipper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 323.45,
    height: 187.112,
    viewBox: "0 0 323.45 187.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BOAT_PLAYER",
    "data-name": "BOAT PLAYER",
    transform: "translate(-195.281 192.629)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "FOND_TRANSPARENT",
    "data-name": "FOND TRANSPARENT",
    width: 323.45,
    height: 150.551,
    transform: "translate(195.281 -157.264)",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "BOAT_03",
    "data-name": "BOAT 03",
    transform: "translate(195.281 -192.629)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "FOND_TRANSPARENT-2",
    "data-name": "FOND TRANSPARENT",
    width: 320.388,
    height: 182.774,
    fill: "#fff",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "BOAT_05",
    "data-name": "BOAT 05",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 7.97, 89.243)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4313",
    "data-name": "Path 4313",
    d: "M18.942,0H2.253A2.253,2.253,0,0,0,0,2.251V2.3A2.252,2.252,0,0,0,2.253,4.549H18.942A2.25,2.25,0,0,0,21.193,2.3V2.251A2.251,2.251,0,0,0,18.942,0Z",
    transform: "translate(265.477 28.32)",
    fill: "#5f5d68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4314",
    "data-name": "Path 4314",
    d: "M1.627,0a2.214,2.214,0,0,0-.27,1.016v.045A2.252,2.252,0,0,0,3.608,3.314H20.3a2.222,2.222,0,0,0,.624-.127,2.229,2.229,0,0,1-1.981,1.235H2.253A2.252,2.252,0,0,1,0,2.171V2.124A2.223,2.223,0,0,1,1.627,0Z",
    transform: "translate(265.477 28.447)",
    fill: "#514d60"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1063",
    "data-name": "Rectangle 1063",
    width: 5.916,
    height: 6.127,
    transform: "translate(273.156 32.87)",
    fill: "#5f5d68"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1064",
    "data-name": "Rectangle 1064",
    width: 5.916,
    height: 1.813,
    transform: "translate(273.156 32.87)",
    fill: "#514d60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4315",
    "data-name": "Path 4315",
    d: "M0,33.737H101.631L68.262,0Z",
    transform: "translate(138.918 5.26)",
    fill: "#62849a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4318",
    "data-name": "Path 4318",
    d: "M0,7.757H310.837V0H0Z",
    transform: "translate(0 38.996)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4319",
    "data-name": "Path 4319",
    d: "M310.837,0H0C8.851,9.046,14.372,32.737,16.7,44.781l.155-.077H279.317C290.634,15.33,310.837,0,310.837,0Z",
    transform: "translate(0 46.753)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4320",
    "data-name": "Path 4320",
    d: "M305.765,4.493H3.444A27.291,27.291,0,0,0,0,0H310.837A62.976,62.976,0,0,0,305.765,4.493Z",
    transform: "translate(0 46.753)",
    fill: "#e0e8f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2570",
    "data-name": "Group 2570",
    transform: "translate(148.784 8.695)",
    style: {
      isolation: "isolate"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4326",
    "data-name": "Path 4326",
    d: "M7.414,0,35.129,30.3H24.363L0,3.664Z",
    transform: "translate(45.308)",
    fill: "#7799af",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4327",
    "data-name": "Path 4327",
    d: "M1.7,0,24.4,24.814H21.926L0,.842Z",
    transform: "translate(39.916 5.487)",
    fill: "#7799af",
    opacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4328",
    "data-name": "Path 4328",
    d: "M3.423,0,21.145,19.376h-4.97L0,1.692Z",
    transform: "translate(27.195 10.925)",
    fill: "#7799af",
    opacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4329",
    "data-name": "Path 4329",
    d: "M5.5,0,20.814,16.738H12.821L0,2.721Z",
    transform: "translate(19.775 13.563)",
    fill: "#7799af",
    opacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4330",
    "data-name": "Path 4330",
    d: "M1.829,0l9.944,10.872H9.117L0,.9Z",
    transform: "translate(11.582 19.429)",
    fill: "#7799af",
    opacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4331",
    "data-name": "Path 4331",
    d: "M1.829,0l7,7.655H6.175L0,.9Z",
    transform: "translate(5.073 22.645)",
    fill: "#7799af",
    opacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4332",
    "data-name": "Path 4332",
    d: "M3.237,0,8.582,5.844h-4.7L0,1.6Z",
    transform: "translate(0 24.457)",
    fill: "#7799af",
    opacity: 0.5
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4321",
    "data-name": "Path 4321",
    d: "M.141,0,0,.077.141.866C.795,4.732,2.9,7.361,5.286,7.361H235.035c.7-2.549,1.481-4.995,2.307-7.361Z",
    transform: "translate(25.454 91.456)",
    fill: "#e0e8f5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4322",
    "data-name": "Path 4322",
    d: "M8.687,0l.023.077.237.789a8.992,8.992,0,0,0,8.678,6.495H8.915A8.992,8.992,0,0,1,.237.866L0,.077.237,0Z",
    transform: "translate(25.454 91.456)",
    fill: "#e0e8f5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4323",
    "data-name": "Path 4323",
    d: "M8.711,0c13.461,9.027,21.867,32.636,25.43,44.7h-8.45l-.237.077C21.9,32.737,13.49,9.046,0,0Z",
    transform: "translate(0 46.753)",
    fill: "#e0e8f5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4324",
    "data-name": "Path 4324",
    d: "M41.574,0c-1.394,2.366-2.709,4.812-3.892,7.361H0C1.183,4.812,2.5,2.366,3.892,0Z",
    transform: "translate(221.222 91.456)",
    fill: "#e0e8f5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4325",
    "data-name": "Path 4325",
    d: "M48.041,0H85.724S54.93,15.33,37.683,44.7H0C17.25,15.33,48.041,0,48.041,0Z",
    transform: "translate(225.114 46.753)",
    fill: "#e0e8f5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4316",
    "data-name": "Path 4316",
    d: "M0,39H15.83L84.092,5.259,78.886,0Z",
    transform: "translate(133.746)",
    fill: "#42647a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2572",
    "data-name": "Group 2572",
    transform: "translate(24.114 53.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2571",
    "data-name": "Group 2571"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4333",
    "data-name": "Path 4333",
    d: "M261.524,1.263,220.66.554,178.776.169C163.452.115,147.108.056,130.762,0L82.748.167,40.863.552C16.344.976,0,1.263,0,1.263l40.863.711c12.258.113,26.561.244,41.885.383l48.014.167,48.014-.167,41.884-.387Z",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4334",
    "data-name": "Path 4334",
    d: "M252.44,1.256,213,.552,172.566.167,126.22,0,79.873.164,39.443.549,0,1.256l39.443.709,40.43.385,46.347.164,46.346-.167L213,1.962C236.663,1.54,252.44,1.256,252.44,1.256Z",
    transform: "translate(1.425 7.427)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4335",
    "data-name": "Path 4335",
    d: "M243.359,1.253l-38.024-.7C193.926.439,180.617.307,166.358.167,152.1.115,136.89.056,121.68,0L77,.164C62.742.305,49.433.437,38.025.547L0,1.253s15.21.284,38.025.707L77,2.343l44.679.164,44.678-.167,38.977-.383Z",
    transform: "translate(2.847 14.851)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4336",
    "data-name": "Path 4336",
    d: "M234.275,1.249l-36.606-.7-37.52-.38L117.137,0,74.126.164l-37.52.38L0,1.249l36.606.7,37.52.38,43.011.164,43.012-.167c13.727-.138,26.538-.27,37.52-.38C219.632,1.528,234.275,1.249,234.275,1.249Z",
    transform: "translate(4.272 22.278)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4337",
    "data-name": "Path 4337",
    d: "M225.189,1.246,190,.547,153.938.167,112.594,0,71.251.164,35.186.545,0,1.246s14.074.279,35.186.7l36.065.378c13.2.054,27.27.108,41.344.164l41.343-.167c13.2-.138,25.51-.268,36.066-.38Z",
    transform: "translate(5.697 29.702)",
    fill: "#e0e8f5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2573",
    "data-name": "Group 2573",
    transform: "translate(24.114 53.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4338",
    "data-name": "Path 4338",
    d: "M261.524,1.263,220.66.554,178.776.169C163.452.115,147.108.059,130.762,0L82.748.167,40.863.552,0,1.263l40.863.711,41.885.385,48.014.164,48.014-.167c15.323-.141,29.625-.272,41.884-.387Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4339",
    "data-name": "Path 4339",
    d: "M252.44,1.256,213,.552,172.566.167,126.22,0,79.873.164,39.443.549,0,1.256l39.443.709,40.43.385,46.347.164,46.346-.167L213,1.962C236.663,1.54,252.44,1.256,252.44,1.256Z",
    transform: "translate(1.425 7.427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4340",
    "data-name": "Path 4340",
    d: "M243.359,1.253l-38.024-.7L166.358.167C152.1.115,136.89.059,121.68,0L77,.167c-14.259.138-27.568.27-38.976.38L0,1.253s15.21.284,38.025.707L77,2.343l44.679.164,44.678-.167,38.977-.383Z",
    transform: "translate(2.847 14.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4341",
    "data-name": "Path 4341",
    d: "M234.275,1.249s-14.643-.279-36.606-.7l-37.52-.38L117.137,0,74.126.164l-37.52.38L0,1.249l36.606.7,37.52.38,43.011.164,43.012-.167,37.52-.38C219.632,1.528,234.275,1.249,234.275,1.249Z",
    transform: "translate(4.272 22.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4342",
    "data-name": "Path 4342",
    d: "M225.189,1.244,190,.545,153.938.164,112.594,0C98.52.054,84.447.11,71.251.162L35.186.542,0,1.244s14.074.279,35.186.7l36.065.378c13.2.054,27.27.108,41.344.164l41.343-.164L190,1.941Z",
    transform: "translate(5.697 29.704)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatComputerSkipper);
export default __webpack_public_path__ + "static/media/boat-computer-skipper.fbdc67bf.svg";
export { ForwardRef as ReactComponent };